<script>
import NavBar from '@components/nav-bar.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'

export default {
  components: { NavBar, BaseVidPLayer },
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: false,
        fluid: true,
        sources: [
          {
            src: require('@assets/videos/journey-2.mp4'),
            type: 'video/mp4',
          },
        ],
      },
    }
  },
}
</script>

<template>
  <div>
    <NavBar />
    <BaseMenuButton />
    <BaseSideDrawer>
      <h2>Pick Your Path</h2>
      <p>
        Explore the Life of Mine. Discover the Hexagon difference. Where would
        you like to start?
      </p>
      <ul class="sidebarNav">
        <li>
          <router-link :to="{ name: 'planning-overview' }">
            <span>01</span>Exploration
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'planning-overview' }">
            <span>02</span>Planning
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'planning-overview' }">
            <span>03</span>Drill &amp; Blast
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'planning-overview' }">
            <span>04</span>Material Movement
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'planning-overview' }">
            <span>05</span>Survey &amp; Monitoring
          </router-link>
        </li>
      </ul>
    </BaseSideDrawer>

    <BaseVidPLayer ref="bgVideo" :options="videoOptions" class="bgVideo" />
    <slot />
  </div>
</template>

<style lang="scss">
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
